import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import * as $ from 'jquery';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { CommonService } from 'src/app/services/common.service';
import { Subject } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  changePasswordForm = new UntypedFormGroup({
    old_password : new UntypedFormControl(''),
    new_password : new UntypedFormControl(''),
    confirm_new_password : new UntypedFormControl('')
  })

  @Input() Content:any;

  old_password_field_req:boolean = true;
  passwordlabel:string = 'Change';

  action: Subject<any> = new Subject();

  constructor(
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    private summaryService: AdministrationSummaryService,
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    if(this.Content.content.old_password_field_req != undefined){
    this.old_password_field_req = this.Content.content.old_password_field_req;
    }
    if(this.Content.heading != undefined){
    this.passwordlabel = this.Content.heading;
    }
  }

  operations = [
    { name: 'Update Password', type:'submit', callback: this.updatePassword, self: this }
  ]

  onCallbackOperation(opr) {
    opr.callback();
  }

  updatePassword() {
    if (this.validateControls()) {
      let Url = '';
      var obj = new Object();
      if(this.Content.content.old_password_field_req){
        Url = 'api/appuser/updatepassword';
        obj['oldPwd'] =  this.changePasswordForm.value.old_password ;
        obj['newPwd'] = this.changePasswordForm.value.new_password;
      }
      else{
        Url = 'api/appuser/setpassword'; 
        obj['newPwd'] = this.changePasswordForm.value.new_password;
      }
      this.summaryService.chagnePassword(Url,obj).subscribe(result => {
        if (result.Status === 0) {
        
        //  this.action.next('okclick');
          if(this.changePasswordForm.value.old_password != "" && this.changePasswordForm.value.old_password != null && this.changePasswordForm.value.old_password != undefined ){
            this.commonService.SuccessBanner("Password has been changed successfully");
            this.modalRef.close('okclick');
          }else{
            this.commonService.SuccessBanner("Password has been reset successfully");
            this.modalRef.close('okclick');
          }
        }
        else {
          this.commonService.ValidationBanner("Your current password is incorrect. Please re-enter the correct password");
        }
      });
    }

  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.changePasswordForm.value;

    if(this.Content.content.old_password_field_req){
      if ((formData.old_password !== null && formData.old_password !== "" && formData.old_password !== undefined) &&  formData.old_password === formData.new_password ) {
    
        message += "Current Password and New Password cannot be same <br/>";
        isValid = false;
      } 

      if (formData.old_password === null || formData.old_password === "" || formData.old_password === undefined) {
        $("#old_password").addClass("ng-touched ng-invalid validate-error");
        $("#old_password").removeClass("ng-untouched ng-valid");
        message += "Please enter Current password <br/>";
        isValid = false;
      } else {
        $("#old_password").addClass("ng-untouched ng-valid");
        $("#old_password").removeClass("ng-touched ng-invalid validate-error");
      }
   }

    if (formData.new_password === null || formData.new_password === "" || formData.new_password === undefined) {
      $("#new_password").addClass("ng-touched ng-invalid validate-error");
      $("#new_password").removeClass("ng-untouched ng-valid");
      message += "Please enter New password <br/>";
      isValid = false;
    } else {
      $("#new_password").addClass("ng-untouched ng-valid");
      $("#new_password").removeClass("ng-touched ng-invalid validate-error");
    }

    if((formData.new_password !== null && formData.new_password !== "" && formData.new_password !== undefined) || (formData.confirm_new_password !== null && formData.confirm_new_password !== "" && formData.confirm_new_password !== undefined)){
      if(formData.new_password.length < 6){
        message += "Password should contain at least 6 characters <br/>";
        isValid = false;
      }
    }

    if (formData.confirm_new_password === null || formData.confirm_new_password === "" || formData.confirm_new_password === undefined) {
     $("#confirm_new_password").addClass("ng-touched ng-invalid validate-error");
     $("#confirm_new_password").removeClass("ng-untouched ng-valid");
     message += "Please enter Confirm password <br/>";
     isValid = false;
    } else {
     $("#confirm_new_password").addClass("ng-untouched ng-valid");
     $("#confirm_new_password").removeClass("ng-touched ng-invalid validate-error");
    }

    // if(formData.confirm_new_password !== null && formData.confirm_new_password !== "" && formData.confirm_new_password !== undefined){
    //   if(formData.confirm_new_password.length < 6){
    //     message += "Confirm Password should contain at least 6 characters <br/>";
    //     isValid = false;
    //   }
    // }

    if (formData.new_password !== formData.confirm_new_password 
    && (formData.confirm_new_password !== null && formData.confirm_new_password !== "")
     && (formData.new_password !== null && formData.new_password !== "") ) {
      $("#new_password").addClass("ng-touched ng-invalid validate-error");
      $("#new_password").removeClass("ng-untouched ng-valid");
      $("#confirm_new_password").addClass("ng-touched ng-invalid validate-error");
      $("#confirm_new_password").removeClass("ng-untouched ng-valid");
      message += "Your new password and confirm password don’t match. Please re-enter valid password <br/>";
      isValid = false;
    } else {
      $("#confirm_new_password").addClass("ng-untouched ng-valid");
      $("#confirm_new_password").removeClass("ng-touched ng-invalid validate-error");
      $("#new_password").addClass("ng-untouched ng-valid");
      $("#new_password").removeClass("ng-touched ng-invalid validate-error");
    } 
    //else {
    //   $("#confirm_new_password").addClass("ng-untouched ng-valid");
    //   $("#confirm_new_password").removeClass("ng-touched ng-invalid validate-error");
    //   $("#new_password").addClass("ng-untouched ng-valid");
    //   $("#new_password").removeClass("ng-touched ng-invalid validate-error");
    // }

    if (!isValid)
    this.commonService.ValidationBanner(message);
    return isValid;
  }

}
